export default [
  {
    name: "Offline Pending Requests",
    path: '/pending-requests',
    component: () => import('../views/offline/PendingRequestList.vue'),
    meta: {
      title: 'screens.offline.PendingRequestList.pageTitle',
    },
  }
]